import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-10px font-medium text-black-lp-300 flex items-center" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bullet_point = _resolveComponent("bullet-point")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_ColumnChart = _resolveComponent("ColumnChart")!
  const _component_CardDashboardClient = _resolveComponent("CardDashboardClient")!

  return (_openBlock(), _createBlock(_component_CardDashboardClient, {
    title: _ctx.$t('dashboard.detail')
  }, {
    "top-right": _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_bullet_point, { class: "text-green-lp-800 w-2 mr-3" }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t("dashboard.totalResi")), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode("div", null, [
        (_ctx.chart.loading)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode(_component_Skeleton, {
                class: "mt-2",
                height: "1rem"
              }),
              _createVNode(_component_Skeleton, {
                class: "mt-2",
                height: "20rem"
              })
            ]))
          : (_openBlock(), _createBlock(_component_ColumnChart, {
              key: 1,
              seriesTitle: _ctx.chartTitle,
              seriesData: _ctx.chart.series,
              categories: _ctx.chart.categories,
              tooltip: true
            }, null, 8, ["seriesTitle", "seriesData", "categories"]))
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}